import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { RegistrationProvider } from "@/context/RegistrationContext";
import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Confirmation from "@/pages/Confirmation";
import StatusLookup from "@/pages/StatusLookup";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Sponsor from "@/pages/Sponsor";
import SponsoredRegister from "@/pages/SponsoredRegister";
import SponsorshipConfirmation from "@/pages/SponsorshipConfirmation";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RegistrationProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/register" element={<Register />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/confirmation/:reference" element={<Confirmation />} />
            <Route path="/status" element={<StatusLookup />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/sponsor" element={<Sponsor />} />
            <Route path="/sponsorship/:reference" element={<SponsorshipConfirmation />} />
            <Route path="/sponsored-register/:token" element={<SponsoredRegister />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </RegistrationProvider>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
